<template>
  <v-app>
    <div class="landing-page">
      <header class="pt-0">
        <public-header :term="term" @doSearch="doSearch"></public-header>
        <img src="@/assets/lp/images/clouds.png" alt="" class="clouds" />
      </header>
      <img src="@/assets/lp/images/fx-1.png" alt="" class="fx-1" /> <img src="@/assets/lp/images/fx-2.png" alt="" class="fx-2" />
      <img src="@/assets/lp/images/fx-3.png" alt="" class="fx-3" />

      <!-- <section class="container-fluid section-2 wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.4s" data-wow-offset="40">
        <div class="row">
          <div class="col-md-12 text-center">
            <h2>Cursos em destaque</h2>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-center">
            <v-progress-linear v-if="loadingCourses" indeterminate></v-progress-linear>
            <carousel v-else :per-page="3" :navigate-to="0" :mouse-drag="false" :navigationEnabled="true" >
              <slide v-for="(course, $index) in courses" :key="$index">
                <v-card
                  class="mx-auto text-center"
                  max-width="400"
                >
                  <v-img
                    class="white--text align-center"
                    height="200px"
                    :src="getCourseImage(course.image)"
                  >
                    <v-card-title class="white--text">{{ course.title }}</v-card-title>
                  </v-img>

                  <v-card-actions class="text-center align-center py-4">
                    <a href="" target="_blank" class="btn blue">Ver mais</a>
                  </v-card-actions>
                </v-card>
              </slide>
            </carousel>
          </div>
        </div>
      </section> -->

      <div class="container-fluid content-search-page">
        <v-row>
          <v-col cols="12" sm="12" class="wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.4s" data-wow-offset="40">
            <h2>Aprender sempre, a cada momento<br /> e em todo lugar!</h2><br />

            <v-text-field
              v-model="term"
              label="Pesquise pelo curso que deseja fazer"
              single-line
              outlined
              class="input-search"
              prepend-inner-icon="search"
              @click:prepend="doSearchTerm"
              @keyup.enter="doSearchTerm"
              clearable
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="12" class="wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.4s" data-wow-offset="40" style="padding-bottom: 0;">
            <h3>Cursos para todos</h3>
            <p>Comece aprender algo novo agora! Escolha entre nossos diversos cursos.</p>
            <div class="divisor"></div>
          </v-col>

          <v-col cols="12" sm="12" md="3" class="wow fadeInUp filter-search" data-wow-duration="1s" data-wow-delay="0.4s" data-wow-offset="40">
            <v-expansion-panels
              focusable
              flat
              :aria-expanded="true"
            >
              <v-expansion-panel>
                <v-expansion-panel-header :disabled="loadingCategories">
                  Categorias
                </v-expansion-panel-header>
                <v-expansion-panel-content class="filter-itens">
                  <v-checkbox v-model="selectedCategories" v-for="(category, i) in categories" :key="`c${i}`" color="#1172BB" :label="category.name" :value="category._id"></v-checkbox>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header>
                  Preço
                </v-expansion-panel-header>
                <v-expansion-panel-content class="filter-itens">
                  <v-checkbox v-model="selectedPrices" v-for="(price, i) in prices" :key="`p${i}`" color="#1172BB" :label="`até R$ ${price}`" :value="price"></v-checkbox>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header>
                  Duração do curso
                </v-expansion-panel-header>
                <v-expansion-panel-content class="filter-itens">
                  <v-checkbox v-model="selectedDuration" v-for="(duration, i) in durations" :key="`d${i}`" color="#1172BB" :label="showDurationLabel(duration)" :value="duration"></v-checkbox>
                </v-expansion-panel-content>
              </v-expansion-panel>

            </v-expansion-panels>
          </v-col>

          <v-col cols="12" sm="12" md="9" class="wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.4s" data-wow-offset="40">
            <div class="filters-selected" v-if="selectedCategories.length || selectedPrices.length || selectedDuration.length">
              <span v-for="(categoryId, i) in selectedCategories" :key="`sc${i}`">
                {{ showCategoryName(categoryId) }} <v-icon @click="removeCategories(categoryId)">close</v-icon>
              </span>
              <span v-for="(price, i) in selectedPrices" :key="`sp${i}`">
                até R$ {{ price }} <v-icon @click="selectedPrices.splice(i, 1)">close</v-icon>
              </span>
              <span v-for="(duration, i) in selectedDuration" :key="`sd${i}`">
                {{ showDurationLabel(duration) }} <v-icon @click="selectedDuration.splice(i, 1)">close</v-icon>
              </span>
            </div>

            <div class="text-center" v-if="loadingCourses">
              <v-progress-circular

                indeterminate
                :size="70"
                :width="7">

              </v-progress-circular>
              <div>Carregando cursos</div>
            </div>

            <div v-if="!loadingCourses && !courses.length">
              <v-alert
                color="#dc1237"
                dark
                class="white-text"
              >
                Nenhum curso encontrado
              </v-alert>
            </div>

            <!-- CARDS CURSOS -->
            <v-row v-if="!loadingCourses && courses.length">

              <v-col cols="12" sm="12" md="6" lg="4" class="card-course" v-for="(course, i) in courses" :key="i">
                <div class="card-course-div">
                  <div :style="`backgroundImage: url(\'${course.imageUrl}\')`" class="img-course" v-if="course.imageUrl"></div>
                  <div class="img-course" v-else></div>
                  <h4>{{ course.title }}</h4>
                  <h5>{{ course.user }}</h5>
                  <v-btn class="outline" color="primary" dark :to="{name: 'sobre-curso', params: {slug: course.slug}}">Ver mais</v-btn>
                </div>
              </v-col>

              <!--
              <v-col cols="12" sm="6" md="4" class="card-course">
                <div class="card-course-div" @click="openCourse">
                  <img src="@/assets/thumb-curso-01.jpg" alt="" class="img-fluid">
                  <h4>Curso de introdução ao Marketing digital</h4>
                  <h5>Viamaker Education</h5>
                  <v-btn class="outline" color="primary" dark>Ver mais</v-btn>
                </div>
              </v-col>

              <v-col cols="12" sm="6" md="4" class="card-course">
                <div class="card-course-div" @click="openCourse">
                  <img src="@/assets/thumb-curso-02.jpg" alt="" class="img-fluid">
                  <h4>Educação financeira para crianças</h4>
                  <h5>Viamaker Education</h5>
                  <v-btn class="outline" color="primary" dark>Ver mais</v-btn>
                </div>
              </v-col>

              <v-col cols="12" sm="6" md="4" class="card-course">
                <div class="card-course-div" @click="openCourse">
                  <img src="@/assets/thumb-curso-03.jpg" alt="" class="img-fluid">
                  <h4>Lógica de programação do básico ao avançado</h4>
                  <h5>Smartoys</h5>
                  <v-btn class="outline" color="primary" dark>Ver mais</v-btn>
                </div>
              </v-col>

              <v-col cols="12" sm="6" md="4" class="card-course">
                <div class="card-course-div" @click="openCourse">
                  <img src="@/assets/thumb-curso-02.jpg" alt="" class="img-fluid">
                  <h4>Educação financeira para crianças</h4>
                  <h5>Viamaker Education</h5>
                  <v-btn class="outline" color="primary" dark>Ver mais</v-btn>
                </div>
              </v-col>

              <v-col cols="12" sm="6" md="4" class="card-course">
                <div class="card-course-div" @click="openCourse">
                  <img src="@/assets/thumb-curso-03.jpg" alt="" class="img-fluid">
                  <h4>Lógica de programação do básico ao avançado</h4>
                  <h5>Smartoys</h5>
                  <v-btn class="outline" color="primary" dark>Ver mais</v-btn>
                </div>
              </v-col>
              -->
            </v-row>
          </v-col>
        </v-row>
      </div>

      <div class="destaque-busca">
        <div class="container-fluid">
          <v-row>
            <v-col cols="12" sm="12" md="6" lg="7" class="wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.4s" data-wow-offset="40">
              <img src="@/assets/lp/images/banner-5.png" alt="" class="img-fluid" />
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="5" class="wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.4s" data-wow-offset="40">
              <h5>Faça parte<br /> dessa inovação!</h5>
              <p>Vamos transformar a educação da sua empresa<br /> de forma segura e personalizada.</p>
              <v-btn dark href="/login" target="_blank">Ensine com a gente</v-btn>
            </v-col>
          </v-row>
        </div>
      </div>

      <footer class="lp"><img src="@/assets/lp/images/mundi-play-logo-rodape.png" alt="" /></footer>

      <v-snackbar
        v-model="alert.show"
        :color="alert.color"
      >
        {{ alert.text }}
      </v-snackbar>
    </div>
  </v-app>
</template>

<script>
  // @ is an alias to /src
  import '@/assets/lp/style.css'
  import '@/assets/lp/animate.min.css'
  import _ from 'lodash'
  import PublicHeader from '@/components/Public/Header'
  import { mapGetters, mapActions } from 'vuex'
  import {WOW} from 'wowjs'

  export default {
    name: 'PublicSearchCourse',
    components: { PublicHeader },
    data: () => ({
      navigationEnabled: false,
      drawer: false,
      loadingCategories: false,
      loadingCourses: true,
      courses: [],
      categories: [],
      prices: [50, 100, 150, 200, 300, 400, 500],
      durations: [
        { min: 0, max: 2 },
        { min: 3, max: 6 },
        { min: 7, max: 10 },
        { min: 10 },
      ],
      selectedCategories: [],
      selectedPrices: [],
      selectedDuration: [],
      term: '',
      alert: {
        show: false,
        text: null,
        color: null
      }
    }),
    computed: {
      ...mapGetters(['getPublicFilters']),
    },
    watch: {
      selectedCategories (val) {
        this.setPublicFilters({
          categories: val
        })
        this.debouncedGetCourses()
      },
      selectedPrices (val) {
        this.setPublicFilters({
          prices: val
        })
        this.debouncedGetCourses()
      },
      selectedDuration (val) {
        this.setPublicFilters({
          durations: val
        })
        this.debouncedGetCourses()
      }
    },
    created () {
      this.startFilters()

      this.getCategories()

      this.debouncedGetCourses = _.debounce(this.getCourses, 200)
    },
    mounted () {
      const wow = new WOW({
          live: false
      });
      wow.init()
    },
    methods: {
      ...mapActions(['setPublicFilters']),
      doSearch () {
        this.term = this.getPublicFilters.term
        this.debouncedGetCourses()
      },
      doSearchTerm () {
        this.setPublicFilters({
          term: this.term
        })
        this.debouncedGetCourses()
      },
      showCategoryName (categoryId) {
        const category = this.categories.find(cat => cat._id === categoryId)

        if (!category) {
          return null
        }

        return category.name
      },
      showDurationLabel (duration) {
        if (duration.hasOwnProperty('min') && duration.hasOwnProperty('max')) {
          return `${duration.min}-${duration.max} Horas`
        }

        if (duration.hasOwnProperty('min') && !duration.hasOwnProperty('max')) {
          return `+${duration.min} Horas`
        }

        return null
      },
      removeCategories (categoryId) {
        // const index = this.selectedCategories.findIndex(catId => catId === categoryId)

        this.selectedCategories.splice(0, 1)

        // this.setPublicFilters({
        //   categories: this.selectedCategories.splice(0, 1)
        // })
      },
      startFilters () {
        if (this.getPublicFilters.categories) {
          this.selectedCategories = this.getPublicFilters.categories
        }

        if (this.getPublicFilters.prices) {
          this.selectedPrices = this.getPublicFilters.prices
        }

        if (this.getPublicFilters.durations) {
          this.selectedDuration = this.getPublicFilters.durations
        }

        if (this.getPublicFilters.term) {
          this.term = this.getPublicFilters.term
        }
      },
      getCourses () {
        this.loadingCourses = true

        const data = {
          categories: this.selectedCategories,
          prices: this.selectedPrices,
          durations: this.selectedDuration,
          term: this.term
        }

        this.axios.post('/public/course/search', data).then(({ data }) => {
          if (data.success) {
            this.courses = data.courses
          } else {
            this.alert.text = data.message
            this.alert.color = 'error'
            this.alert.show = true
          }
        }).catch(err => {
          console.error(err)

          this.alert.text = 'Erro ao buscar o curso'
          this.alert.color = 'error'
          this.alert.show = true
        }).finally(() => {
          this.loadingCourses = false
        })
      },
      getCategories () {
        this.loadingCategories = true

        this.axios('/public/categories/combo').then(({ data }) => {
          if (data.success) {
            this.categories = data.categories
          }
        }).catch(err => {
          console.error(err)
        }).finally(() => {
          this.loadingCategories = false
        })
      }
    }
  }
</script>
